// @flow
import {CVSContentfulLocaleMap, campaignId} from '../constants/appsConstants';
import {isTestExperience} from './TestUtil';

export function getContentfulPath(sapcode: string, locale: string) {
	const contentfulLocal = CVSContentfulLocaleMap[locale];
	switch (sapcode.toLowerCase().trim()) {
		case 'gethelpconfig':
			return `/content/dam/cvs/ccdesktop/206/4etKge5E7WprLMCq8oxbNJ/${contentfulLocal}.json`;
		case 'gethelpconfigcampaign':
			return `/content/dam/cvs/ccdesktop/368/74xStjSdiZhvuyRTzBk7Is/${contentfulLocal}.json`;
		case 'gethelpconfigccpp':
			return `/content/dam/cvs/ccdesktop/687/5E2sRT5XEvUZ1xWJCBdJN3/${contentfulLocal}.json`;
		case 'gethelpconfigccppn':
			return `/content/dam/cvs/ccdesktop/606/1SfZpSvn5bPT5VjfuYiCXP/${contentfulLocal}.json`;
		case 'gethelpconfigsingleapp':
			return `/content/dam/cvs/ccdesktop/482/4GpMeiZqWnea91eKaXyoHJ/${contentfulLocal}.json`;
		case 'getapppickerconfig':
			return `/content/dam/cvs/ccdesktop/511/4rlsAMCIrWRDeNMphaozrV/${contentfulLocal}.json`;
		case 'getapppickerconfigccpp':
			return `/content/dam/cvs/ccdesktop/683/KlLTSpdbGZKXsqwfF3Wmd/${contentfulLocal}.json`;
		case 'getapppickerconfigccppn':
			return `/content/dam/cvs/ccdesktop/608/18KnbkhDj4T0IFk4SJBaRb/${contentfulLocal}.json`;
		case 'getapppickerconfig-illustrator':
			return `/content/dam/cvs/ccdesktop/75/6rLYBCsJK5DPChw553zZWo/${contentfulLocal}.json`;
		case 'getapppickerconfig-xd':
			return `/content/dam/cvs/ccdesktop/631/2Y3O8W0CEupa5lnFn2h1AR/${contentfulLocal}.json`;
		case 'getapppickerconfig-incopy':
			return `/content/dam/cvs/ccdesktop/895/5esNg7NIfTmK5XupF3Ionw/${contentfulLocal}.json`;
		case 'getapppickerconfig-audition':
			return `/content/dam/cvs/ccdesktop/780/WIP1BuXDrnP58qOfGgSoV/${contentfulLocal}.json`;
		case 'getapppickerconfig-dimension':
			return `/content/dam/cvs/ccdesktop/859/12TuSGSWAKe1zaETYX557Z/${contentfulLocal}.json`;
		case 'getapppickerconfig-dreamweaver':
			return `/content/dam/cvs/ccdesktop/700/6IDmOYHba8y14uFIQN8a7N/${contentfulLocal}.json`;
		case 'getapppickerconfig-animate':
			return `/content/dam/cvs/ccdesktop/792/3OW194O4GwbNeFEDC6pnAJ/${contentfulLocal}.json`;
		case 'getapppickerconfig-lightroom':
			return `/content/dam/cvs/ccdesktop/717/5K9Hh3LDqZIiIwT2IKFWWX/${contentfulLocal}.json`;
		case 'getapppickerconfig-aftereffects':
			return `/content/dam/cvs/ccdesktop/329/2jbiD0VZ8TeZMfsLM12X1q/${contentfulLocal}.json`;
		case 'getapppickerconfig-indesign':
			return `/content/dam/cvs/ccdesktop/830/3jgUcHJE4oV26I4tSBAqnC/${contentfulLocal}.json`;
		case 'getapppickerconfig-premiere-rush':
			return `/content/dam/cvs/ccdesktop/431/29nqjjXuaZLroePfcQ6Xwl/${contentfulLocal}.json`;
		case 'getapppickerconfig-premiere':
			return `/content/dam/cvs/ccdesktop/795/4oSrh3l2q6O4Ybx2bMncIz/${contentfulLocal}.json`;
		case 'getapppickerconfig-acrobat':
			return `/content/dam/cvs/ccdesktop/420/2gyBKNbYEAGHpOqe4oC0Du/${contentfulLocal}.json`;
		case 'getapppickerconfig-photoshop':
			return `/content/dam/cvs/ccdesktop/610/1X44nCdJgEKvWKowNYAWmw/${contentfulLocal}.json`;
		case 'skeletonwithstock':
			return isTestExperience(campaignId.categoryPageRevampTest)
				&& locale === 'en'
				? `/content/dam/cvs/ccdesktop/702/7xLBr9YxG8aPrsFCun38Tg/${contentfulLocal}.json`
				: `/content/dam/cvs/ccdesktop/639/3aPzsIInnjJ9AuPsKyWzoU/${contentfulLocal}.json`;
		case 'allappbanners':
			return `/content/dam/cvs/ccdesktop/403/5TAaiKBS2jksm2MXIkLOge/${contentfulLocal}.json`;
		case 'categoriesbanners':
			return `/content/dam/cvs/ccdesktop/734/39cGZ8rZQSg68xzby8Oh2Z/${contentfulLocal}.json`;
		case 'videocardsinfoilst':
			return `/content/dam/cvs/ccdesktop/164/4cBl217Z2IFclfGgXl53TQ/${contentfulLocal}.json`;
		case 'videocardsinfophsp':
			return `/content/dam/cvs/ccdesktop/652/0hhWriXa0nbCxK6CchBz3/${contentfulLocal}.json`;
		case 'rush':
			return `/content/dam/cvs/ccdesktop/299/6mu0F3nGfdpU8Nd6xpHfre/${contentfulLocal}.json`;
		case 'phsp':
			return `/content/dam/cvs/ccdesktop/41/38JasXWkB6mZgXnobSDKjT/${contentfulLocal}.json`;
		case 'ilst':
			return `/content/dam/cvs/ccdesktop/181/4BtijjOCa8N66ERScALUTr/${contentfulLocal}.json`;
		case 'idsn':
			return `/content/dam/cvs/ccdesktop/557/2AyOpkOkpKf0UIPSNMcu0B/${contentfulLocal}.json`;
		case 'sprk':
			return `/content/dam/cvs/ccdesktop/725/Vld0P3UJYcWk5VGHbr64a/${contentfulLocal}.json`;
		case 'ppro':
			return `/content/dam/cvs/ccdesktop/907/YAdUxqa24EzVpFvxP09By/${contentfulLocal}.json`;
		case 'aeft':
			return `/content/dam/cvs/ccdesktop/872/4z294D5L1h8wQqHzUq9Jzq/${contentfulLocal}.json`;
		case 'eshr':
			return `/content/dam/cvs/ccdesktop/273/5bWPHn39UuhSUbNMSUixMB/${contentfulLocal}.json`;
		case 'lrcc':
			return `/content/dam/cvs/ccdesktop/874/1Nt5Q5cV19ZHympoPpDRdf/${contentfulLocal}.json`;
		case 'ltrm':
			return `/content/dam/cvs/ccdesktop/636/3KNY0jhM5TgnH1SUlDI6QQ/${contentfulLocal}.json`;
		case 'apro':
			return `/content/dam/cvs/ccdesktop/163/3g6z3UNKjnrwEpj4fJM4BJ/${contentfulLocal}.json`;
		case 'drwv':
			return `/content/dam/cvs/ccdesktop/892/3VWfMOkIWHSPJ9QcaqMEyH/${contentfulLocal}.json`;
		case 'muse':
			return `/content/dam/cvs/ccdesktop/766/3mIgzdV5eQflsPrLgFb3OX/${contentfulLocal}.json`;
		case 'flpr':
			return `/content/dam/cvs/ccdesktop/144/6QHdQLtIOi1fvTVVcIDZKG/${contentfulLocal}.json`;
		case 'char':
			return `/content/dam/cvs/ccdesktop/815/13uUi57ghiCrU56nREji4p/${contentfulLocal}.json`;
		case 'audt':
			return `/content/dam/cvs/ccdesktop/574/xmCUR14WQ72N6ko8CIYw1/${contentfulLocal}.json`;
		case 'kbrg':
			return `/content/dam/cvs/ccdesktop/505/2BYbDSpKOHnaFNVr5rJ5aU/${contentfulLocal}.json`;
		case 'ame':
			return `/content/dam/cvs/ccdesktop/700/2Cicd1R0ckQODG3ABpDFtQ/${contentfulLocal}.json`;
		case 'aicy':
			return `/content/dam/cvs/ccdesktop/823/2p3Un9Z3VvmQiFfhqDppcA/${contentfulLocal}.json`;
		case 'prld':
			return `/content/dam/cvs/ccdesktop/886/49GM88a5mjPLXb4kZWBCdz/${contentfulLocal}.json`;
		case 'fuse':
			return `/content/dam/cvs/ccdesktop/246/6DTOQxfoPzKlZFK1qT6Odw/${contentfulLocal}.json`;
		case 'kccc':
			return `/content/dam/cvs/ccdesktop/74/2GcuCNwdf7Y9MFZzawzCYl/${contentfulLocal}.json`;
		case 'sbsta':
			return `/content/dam/cvs/ccdesktop/626/D0Sd8WZePlBbCZtZYLF9c/${contentfulLocal}.json`;
		case 'sbstp':
			return `/content/dam/cvs/ccdesktop/983/4Z3UDOjGy0UXfVWP0df5DD/${contentfulLocal}.json`;
		case 'sbstd':
			return `/content/dam/cvs/ccdesktop/141/7vm620pehp3f6GVf6BB3dx/${contentfulLocal}.json`;
		case 'aero':
			return `/content/dam/cvs/ccdesktop/68/2Ee74Z5q3G7Aq7M0nXLnow/${contentfulLocal}.json`;
		case 'ffc_behance':
			return `/content/dam/cvs/ccdesktop/514/7nDTHMI819r81mV99PsgrJ/${contentfulLocal}.json`;
		case 'ffc_lightroomweb':
			return `/content/dam/cvs/ccdesktop/608/183G8uVA9Pq8zeJdYsQe6h/${contentfulLocal}.json`;
		case 'ffc_portfolio':
			return `/content/dam/cvs/ccdesktop/265/7p0J5gYmTT8sSb11A8D1bL/${contentfulLocal}.json`;
		case 'ffc_color':
			return `/content/dam/cvs/ccdesktop/564/gFx0b2KqzBjKfQEg12usI/${contentfulLocal}.json`;
		case 'ffc-sprk':
			return `/content/dam/cvs/ccdesktop/690/4JBa662HNuFmZeOpZdNUGC/${contentfulLocal}.json`;
		case 'ffc_stock':
			return `/content/dam/cvs/ccdesktop/310/6cUBtapQ3huIekE7gmjDMq/${contentfulLocal}.json`;
		case 'adobe-fonts':
			return `/content/dam/cvs/ccdesktop/219/2UY6PPXcwFnyq2cBMTlhSs/${contentfulLocal}.json`;
		case 'frsc':
			return `/content/dam/cvs/ccdesktop/533/M79LUfnBzCexKnmAFmMP0/${contentfulLocal}.json`;
		case 'ffc_fresco':
			return `/content/dam/cvs/ccdesktop/810/51NLDMv4VvjWI8cjEz39Tl/${contentfulLocal}.json`;
		case 'ffc_photoshop':
			return `/content/dam/cvs/ccdesktop/911/4i20hmsaBvwZFsoazQdDkv/${contentfulLocal}.json`;
		case 'ffc_aero':
			return `/content/dam/cvs/ccdesktop/936/2kvYrdnkcQ98DfDy0N8Rc0/${contentfulLocal}.json`;
		case 'ffc_sbstsource':
			return `/content/dam/cvs/ccdesktop/891/6vgVj1oOEd2J4Lrf0GnrfX/${contentfulLocal}.json`;
		case 'ffc_mixamo':
			return `/content/dam/cvs/ccdesktop/990/16Wi16I83MON4gPfv0w1Hx/${contentfulLocal}.json`;
		case 'ffc_rush':
			return `/content/dam/cvs/ccdesktop/474/7eMHVW8lki5sLnbegKnMzn/${contentfulLocal}.json`;
		case 'ffc_mbehance':
			return `/content/dam/cvs/ccdesktop/390/4Uv1e4hFDFc1xuFov93eix/${contentfulLocal}.json`;
		case 'ffc_capture':
			return `/content/dam/cvs/ccdesktop/284/5U8LzSRW0g8PULCXc716lT/${contentfulLocal}.json`;
		case 'ffc_comp':
			return `/content/dam/cvs/ccdesktop/777/2Zj471o8H3Kryi73Zqn72l/${contentfulLocal}.json`;
		case 'ffc_ccmob':
			return `/content/dam/cvs/ccdesktop/90/1y1FGBMSTj9OssQOOSC2NR/${contentfulLocal}.json`;
		case 'ffc_draw':
			return `/content/dam/cvs/ccdesktop/419/3L9ILACfLGsVBb566yQUZQ/${contentfulLocal}.json`;
		case 'ffc_lightroom':
			return `/content/dam/cvs/ccdesktop/933/pcN4Ex6wVoBV8CsMeTdU3/${contentfulLocal}.json`;
		case 'ffc_psfix':
			return `/content/dam/cvs/ccdesktop/229/368kLOT6VEfoRdhZXxFXT0/${contentfulLocal}.json`;
		case 'ffc_psmix':
			return `/content/dam/cvs/ccdesktop/469/3dhg6E1hnKC6uF0G3lIGRH/${contentfulLocal}.json`;
		case 'ffc_sketch':
			return `/content/dam/cvs/ccdesktop/222/vzerNtiIjkQsCmkGAnrYj/${contentfulLocal}.json`;
		case 'ffc_acrobat':
			return `/content/dam/cvs/ccdesktop/613/5NqnfVb02WrLjZJlCQJZ7e/${contentfulLocal}.json`;
		case 'ffc_scan':
			return `/content/dam/cvs/ccdesktop/68/6gjdJaYLapgdKjRKJb00to/${contentfulLocal}.json`;
		case 'premiere-clip':
			return '';
		case 'ffc_xd':
			return `/content/dam/cvs/ccdesktop/655/7qmTjrkW4Nk6hT6CR5ZG7y/${contentfulLocal}.json`;
		case 'ffc_sppage':
			return `/content/dam/cvs/ccdesktop/926/1sSrp0f29Ulb5q0rvtCAaM/${contentfulLocal}.json`;
		case 'ffc_spvideo':
			return `/content/dam/cvs/ccdesktop/837/7dSeZCbfL43f8UZWkO3Sx4/${contentfulLocal}.json`;
		case 'ffc_psexp':
			return `/content/dam/cvs/ccdesktop/284/6YyrkGCO5jsJyycFvpv4cG/${contentfulLocal}.json`;
		case 'ffc_sppost':
			return `/content/dam/cvs/ccdesktop/397/2biGadUSxFbSOeRvwchKe0/${contentfulLocal}.json`;
		case 'ffc_fonts':
			return `/content/dam/cvs/ccdesktop/219/2UY6PPXcwFnyq2cBMTlhSs/${contentfulLocal}.json`;
		case 'ffc_live':
			return `/content/dam/cvs/ccdesktop/869/3CMDBdCQc2EGdLBT85W6hS/${contentfulLocal}.json`;
		case 'ffc_fillsign':
			return `/content/dam/cvs/ccdesktop/993/beAeF93DtMUwcUv2rWSql/${contentfulLocal}.json`;
		case 'ffc_dcweb':
			return `/content/dam/cvs/ccdesktop/956/4G04vNa1TYgOPScE1tKM7Z/${contentfulLocal}.json`;
		case 'ffc_sign':
			return `/content/dam/cvs/ccdesktop/558/4J5rPWoQiQCpOWsvHOruIt/${contentfulLocal}.json`;
		case 'ffc_illustrator':
			return `/content/dam/cvs/ccdesktop/711/4ohwnuX9LwbEppxjz1UlIq/${contentfulLocal}.json`;
		case 'ffc_phylo':
			return `/content/dam/cvs/ccdesktop/636/6820FzGRjpHQCxLIDZbEGI/${contentfulLocal}.json`;
		default:
			return '';
	}
}
